/**
 * O último pool aberto neste navegador. Voltar para ``/pools`` reabre ele; sem
 * nenhum guardado (ou com o guardado apagado), abre o primeiro do carrossel.
 * Conveniência por navegador, então ``localStorage`` — e sem ele (aba privada,
 * armazenamento bloqueado) a tela sempre abre no primeiro.
 */

const KEY = 'prism.pools.lastSlug'

export function readLastPool(): string | null {
  try {
    const raw = window.localStorage.getItem(KEY)
    return raw ? raw : null
  } catch {
    return null
  }
}

export function rememberPool(slug: string): void {
  try {
    window.localStorage.setItem(KEY, slug)
  } catch {
    /* armazenamento indisponível: segue sem lembrar */
  }
}

/** Esquece ``slug`` se for ele o guardado — um pool apagado não deve reabrir. */
export function forgetPool(slug: string): void {
  try {
    if (window.localStorage.getItem(KEY) === slug) window.localStorage.removeItem(KEY)
  } catch {
    /* idem */
  }
}

/** O pool a abrir em ``/pools``: o guardado, se ele ainda existe; senão o primeiro. */
export function poolToReopen(last: string | null, slugs: readonly string[]): string | null {
  return last && slugs.includes(last) ? last : (slugs[0] ?? null)
}

/** A busca que segue para a rota do pool: só o canal ativo, como nas outras telas. */
export function keepChannel(prev: { channel?: string | undefined }): { channel?: string } {
  return prev.channel ? { channel: prev.channel } : {}
}
